import apiErrors from './apiErrors';
import clearFiltersOnRouteChange from './clearFiltersOnRouteChange';

export default [apiErrors, clearFiltersOnRouteChange];
